<h2 mat-dialog-title>Add To Do Item</h2>

<div class="metadata-padding" fxLayout="column" [formGroup]="formGroup">

  <lgd-select class="selectPadding" controlName="entityType" label="Entity Type" placeholder="Select an Entity Type"
    [options]="entityTypesObservable">
  </lgd-select>

  @if (isCustom) {
    <lgd-text controlName="customEntity" label="Custom Item">
    </lgd-text>
  }

  @if (!isCustom) {
    <lgd-typeahead controlName="entity" label="Entity" [options]="entitiesObservable"
      (searchTextChanged)="lookupEntities($event)">
    </lgd-typeahead>
  }

  <lgd-text controlName="note" label="To Do Note" telemetry="Edit-Note-ToDoItem-UtilityBilling">
  </lgd-text>

  <lgd-date-picker controlName="dueDate" label="Due Date" placeholder="Choose a Due Date"
    telemetry="Edit-DueDate-ToDoItem-UtilityBilling">
  </lgd-date-picker>

  @if(isSaving) {
    <forge-linear-progress mode="indeterminate"></forge-linear-progress>
  }
</div>

<mat-dialog-actions fxLayoutAlign="end start">
  <forge-button telemetry="Submission-Cancel-ToDoItem-UtilityBilling" mat-dialog-close>
    Cancel
  </forge-button>

  <forge-button (click)="add()" telemetry="Submission-Approve-ToDoItem-UtilityBilling">
    Add
  </forge-button>

  <!-- <button mat-button color="primary" mat-dialog-close telemetry="Submission-Cancel-ToDoItem-UtilityBilling">
  Cancel
</button> -->

<!-- <button mat-button color="primary" (click)="add()" telemetry="Submission-Approve-ToDoItem-UtilityBilling">
Add
</button> -->
</mat-dialog-actions>